/*###########################################################################
// App
//#########################################################################*/

/* CSS
//------------------*/

import "@css/app.css";

/* App
//------------------*/

window.app = {
  disableScroll() {
    document.documentElement.style.overflow = 'hidden'
  },

  enableScroll() {
    document.documentElement.style.overflow = ''
  }
}

/* Third party
//------------------*/

import "./thirdParty"

/* Vendor
//------------------*/

import '@js/vendor/index'

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
*/
import Alpine from 'alpinejs';
import contactForm from "@/js/components/_contactForm";
import header from "@/js/components/_header";

/* Register components */
Alpine.data('contactForm', contactForm);
Alpine.data('header', header);

Alpine.start();

/* Utilities
//------------------*/

import '@js/utilities/_initComponent'

/* Components
//------------------*/

import '@js/components/index'

/* Barba / Lenis / Page Transition
//------------------*/

import { gsap } from 'gsap'
import barba from '@barba/core';
import Lenis from 'lenis'
import { scrollTo } from './utilities/_scrollTo'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

window.lenis = new Lenis({
	syncTouch: true,
	lerp: 0.125
})

window.addEventListener('load', function () {
  window.lenis.on('scroll', (e) => {
    // console.log(e)
  })

  function raf(time) {
    window.lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
})

const pageTransition = document.querySelector('.pageTransition')
const pageTransitionPanels = pageTransition.querySelectorAll('.pageTransition__panel')
let isTransitioning = false

const tlPageTransition = gsap.timeline({
	paused: true,
	onComplete: (timeline) => {
		tlPageTransition.restart()
		tlPageTransition.pause()
	}
})

for (let i = 0; i < pageTransitionPanels.length; i++) {
	const panel = pageTransitionPanels[i]

	gsap.set(panel, {
		x: -window.innerWidth,
	})

	window.addEventListener('resize', () => {
		if (!isTransitioning) {
			gsap.set(panel, {
				x: -window.innerWidth,
			})
		}
	})

	if (i == 0) {
		tlPageTransition.to(panel, {
			duration: 0.25,
			ease: "power1.out",
			x: 0
		})
	} else {
		tlPageTransition.to(panel, {
			duration: 0.25,
			ease: "power1.out",
			x: 0
		}, ">-" + (0.25))
	}

	if (i == 1) {
		tlPageTransition.to(panel, {
			duration: 0.35,
			ease: "power1.out"
		}, "+=0.35")
	}

	tlPageTransition.to(panel, {
		duration: 0.25,
		ease: "power1.out",
		x: 0,
		opacity: 0
	}, ">-" + (0.25))
}

barba.init({
	transitions: [{
		sync: true,
		name: 'opacity-transition',
		beforeLeave(data) {
			const beforeEnterEvent = new CustomEvent('before-page-change')
			window.dispatchEvent(beforeEnterEvent)

			tlPageTransition.play()
			isTransitioning = true
		},
		enter(data) {
			if (window.lenis !== undefined) {
				window.app.disableScroll()
				window.lenis.stop()
			}

			setTimeout(function() {
				document.documentElement.scrollTop = 0
			}, 500)

			setTimeout(function() {
				if (window.lenis !== undefined) {
					window.app.enableScroll()
					window.lenis.start()
				}
			}, 2500)
		},
		after(data) {
			const enterEvent = new CustomEvent('page-change')
			window.dispatchEvent(enterEvent)
		},
		afterEnter({ trigger }) {
			const afterEnterEvent = new CustomEvent('after-page-change')
			window.dispatchEvent(afterEnterEvent)

			isTransitioning = false

			setTimeout(function() {
				if (trigger && trigger.hash) {
					const target = document.querySelector(trigger.hash)

					if (target !== null) {
						const offsetAmount = document.querySelector('.header').clientHeight + (window.innerWidth < 1024 ? 140 : 80)
						scrollTo(target, -offsetAmount)
					}
				}
			}, 1500)
		}
	}],
	preventRunning: true,
	timeout: 7500,
	prevent: ({ href }) => {
    // Prevent if the link's href matches the current page URL
		if (href === window.location.href) {
			return true
		}

		// Disable incoming and outgoing barba for specific slug
		// if (window.location.href.indexOf('slug') !== -1) {
		// 	return true
		// } else if (href.indexOf('slug') !== -1) {
		// 	return true
		// }
  }
})

barba.hooks.leave(() => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 250)
  })
})

barba.hooks.beforeEnter(({ next }) => {
	setTimeout(() => {
		if (typeof htmx !== 'undefined') {
			htmx.process(next.container)
		}
	}, 250)
})

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
